import CustomSlickSlider from '@/components/CustomSlickSlider';
import styled from '@emotion/styled';
import xw from 'xwind';

export const Wrapper = styled.div`
  ${xw('mb-10')}

  padding: 20px 30px;
  border: 3px solid #f3f4f8;

  grid-area: image;
  border-radius: 20px;
`;

export const HeaderContainer = styled.div`
  ${xw('flex justify-between items-center')}
`;

export const Name = styled.h1`
  ${xw('leading-10')}

  font-size: 1.875rem;
`;

export const Price = styled.h2`
  ${xw('font-bold leading-10')}

  font-size: 1.875rem;
`;

export const Producer = styled.h3`
  ${xw('font-normal leading-4 mt-5 mb-7')}

  color: #5fa3a9;
  font-size: 1.25rem;
`;

export const ProductSlider = styled(CustomSlickSlider)`
  margin: 0 25px 20px 25px;

  .slick-track {
    display: flex;
    margin: 0;

    .slick-slide {
      margin-bottom: 15px;
    }
    @media (min-width: 375px) {
      height: 400px;
    }
  }

  .slick-next:before,
  .slick-prev:before {
    content: '';
  }

  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus {
    outline: inherit;
    color: ${xw`text-gray-200`};
    background: ${xw`bg-white`};
  }

  .slick-dots {
    left: -7px;
    text-align: center;

    li {
      button::before {
        font-size: 16px;
        color: #5fa3a9;
      }
    }
  }
`;
